import { useMutation } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { createBoardDirectory, createManyBoardDirectories } from '../functions/boardDirectories';

export const useCreateBoardDirectory = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createBoardDirectory,
    mutationKey: ['create-board-directory'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating board directory', e);
    }
  });
};

export const useCreateManyBoardDirectories = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createManyBoardDirectories,
    mutationKey: ['create-many-board-directories'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating board directories', e);
    }
  });
};
